<template>
    <span class="signe">
      &lt;
    </span>
</template>
